<template>
  <el-select
    ref="select"
    reserve-keyword
    filterable
    remote
    :remote-method="remoteMethod"
    @change="onChange"
    v-bind="$attrs"
  >
    <el-option
      v-for="item in options"
      :key="item.Id"
      :value="item.Id"
      :label="item.Name"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  data() {
    return {
      options: [],
    };
  },
  methods: {
    remoteMethod(key = null) {
      this.$apis.organize.customer
        .list({
          keyWord: key,
          index: 1,
          size: 10,
        })
        .then((res) => {
          this.options = res.Items;
        });
    },
    onChange(e) {
      var res = this.options.find((t) => t.Id == e) || { Name: e };
      this.$emit("change", res);
    },
  },
};
</script>
